<template>
    <div class="mc-lefted">Собеседник покинул чат</div>
</template>

<style scoped lang="scss">
.mc-lefted {
    padding: 14px 16px;
    font-size: 13px;
    color: var(--mc-fg-mute);
    text-align: center;
    border-top: 1px solid var(--mc-line-hard);
}
</style>
